export const event = state => state.event;
export const host = state => state.host;
export const savedGuests = state => state.savedGuests;
export const eventGuests = state => state.eventGuests;
